import React, { FC } from 'react';
import { ReactComponent as FlashIcon } from 'assets/icons/update-surge-modal-icon.svg';
import { ReactComponent as DateSeperatorIcon } from 'assets/icons/date-seperator.svg';
import './styles.scss';
import { ScheduledSurgeTabType } from '../surge-tabs/types';
import { ScheduleSurgeType } from 'models/surge.model';
import { formatSurgeDate, getUserName } from 'utils/functions';

type ScheduledSurgeCardType = {
  type: ScheduledSurgeTabType;
  surge: ScheduleSurgeType;
  isLastItem: boolean;
  onClick: (item: any) => void;
};

const ScheduledSurgeCard: FC<ScheduledSurgeCardType> = ({ onClick, type, surge, isLastItem }) => {
  const surgeDate = formatSurgeDate(surge?.surge_task?.surge_task_date);
  const formatedSurgeDate = `${surgeDate?.startDate.toDateString()} ${
    surgeDate?.endDate !== surgeDate?.startDate ? `-  ${surgeDate?.endDate.toDateString()}` : ''
  }`;
  return (
    <div className='w-full flex justify-between mt-4'>
      <div className='hidden md:block pl-[10px] mt-2'>
        <div className='flash_icon_wrapper mr-6'>
          <FlashIcon />
        </div>
      </div>

      <div
        className={`flex justify-start items-start gap-2 grow ${
          isLastItem ? '' : 'border-b'
        } border-b-[#ebebeb] pb-3`}>
        <div className='grow'>
          <p className='mb-1 text-sm leading-[22px]'>
            <span className='capitalize'>{getUserName(surge.user)}</span> set surge by &nbsp;
            {`${surge?.logistics_surge}x`}
          </p>
          <div className='flex justify-start items-center text-[#858585] text-xs'>
            <p className='mr-1'>{formatedSurgeDate}</p>
            <DateSeperatorIcon />
            <p className='mx-1 flex'>
              {new Date(surge.created_at).toLocaleTimeString('en-US', {
                hour12: false,
                timeStyle: 'short'
              })}
            </p>
            {type === 'Recurrent Surge' && (
              <div className='flex items-center mx-1'>
                <DateSeperatorIcon />
                <p className='text-[#0EA3FD] mx-[6px] capitalize'>
                  {surge?.surge_task?.repeat_time_frames.map((item: string) => (
                    <span key={item}>{item}</span>
                  ))}
                </p>
              </div>
            )}
          </div>
        </div>
        <p
          onClick={onClick}
          className='text-[#E60A2B] cursor-pointer underline font-medium text-sm'>
          Edit
        </p>
      </div>
    </div>
  );
};

export default ScheduledSurgeCard;
